module.exports = __webpack_public_path__ + "static/media/statistic.399baa08.svg";